import React, { useState, useEffect, useContext } from 'react';
import Styles from './TvOptionsContainer.module.scss';
import { Form } from 'react-bootstrap';
import RichText from '../richtext';
import { getStaticAssetPath } from '../../utils/global';
import { countZero, replacePlaceholder } from '../../utils/utils';
import { createPortal } from 'react-dom';
import OttServiceOptionsPopup from './OttServiceOptions/OttServiceOptionsPopup';
import { AssetPathPropConfig } from '../../services/LineTableBasicPropConfig';
import ToolTip from '../ToolTip/ToolTip';
import { AppContext } from './StaticLineTableStore/StaticLineTableProvider';

const TvOptionsContainer = ({
    content,
    constants,
    metadata,
    setTvOptionsData
}: any) => {
    const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();
    const [iconSource, setIconSource] = useState('');
    const [optionToggle, setOptionToggle] = useState<boolean>(false);
    const [selectedOptions, setSelectedOptions] = useState<any[]>([]);
    const [showPopup, setShowPopup] = useState(false);
    const [originalPrice, setOriginalPrice] = useState(0);
    const [discountedPrice, setDiscountedPrice] = useState(0);
    const [responseList, setResponseList] = useState([]);
    const [contractDuration, setContractDuration] = useState(0);
    const [sbMatchedOptions, setSbMatchedOptions] = useState([]);
    const portalPosition: any =
        typeof window !== undefined && document.getElementById('static-linetable');
    const darkTheme = content?.optionTheme && content?.optionTheme === 'dark';
    const context = useContext(AppContext);

    useEffect(() => {
        setHeaderIcon();
    }, [content]);

    const setHeaderIcon = () => {
        if (darkTheme) {
            if (selectedOptions?.length > 0) {
                setIconSource('/icons/device_edit_white.svg');
            } else {
                setIconSource('/icons/plus.svg');
            }
        } else {
            if (selectedOptions?.length > 0) {
                setIconSource('/icons/edit-red.svg');
            } else {
                setIconSource('/icons/circle-plus.svg');
            }
        }
    };

    const calculatePrice = (optionsList: any[]) => {
        let totalPrice = 0;
      let discountPrice = 0;
      let baseToDiscount = 0;
      let contract: number[] = [];
      if (optionsList?.length > 0) {
          (optionsList || [])?.forEach((item: any) => {
            if (item?.beneficiaryPrice > 0) {
                discountPrice += parseFloat(item?.beneficiaryPrice);
            } else if (item?.derivedPrice > 0) {
              discountPrice += parseFloat(item?.derivedPrice);
              contract.push(item?.discountDuration ?? 0);
            } else {
              baseToDiscount += parseFloat(item?.recurringPrice);
            }
            if (item?.recurringPrice > 0) {
              totalPrice += parseFloat(item?.recurringPrice);
            }
          });
          if (discountPrice > 0) {
            discountPrice += baseToDiscount;
          }
      }
      setOriginalPrice(totalPrice);
      setDiscountedPrice(discountPrice);
      contract?.length > 0 ? setContractDuration(Math.min(...contract)) : setContractDuration(0);
    }

    useEffect(() => {
        if (content?.optionType !== 'multi-popup') {
            if (optionToggle) {
                setSelectedOptions(sbMatchedOptions);
            } else {
                setSelectedOptions([]);
            }
        }
    }, [optionToggle]);

    useEffect(() => {
      setHeaderIcon();
      setTvOptionsData(selectedOptions);
      if (content?.optionType === 'multi-popup') {
          calculatePrice(selectedOptions);
      }
    }, [selectedOptions]);

    useEffect(() => {
      calculatePrice(sbMatchedOptions);
    }, [sbMatchedOptions])
    

    useEffect(() => {
    if (context) {
        const { store } = context;
        if (store?.ottOptionsApi?.length > 0 && responseList?.length === 0) {
            setResponseList(store?.ottOptionsApi);
        }
    }
    }, [context]);
    
    useEffect(() => {
        if (responseList?.length > 0 && content?.optionId?.length > 0 && (content?.optionType === 'multi-switcher' || content?.optionType === 'single-switcher' || content?.optionType === 'multi-switcher-v2')) {
            const optionIdList = (content?.optionId || [])?.map((resp: any) => {
                return resp?.text;
            });
            if (optionIdList?.length > 0) {
                let matchingOptions: any = [];
                (responseList || [])?.forEach((resp: any) =>{
                    const matched = (resp?.serviceOption || [])?.filter((opt: any) => optionIdList?.includes(opt?.id));
                    matched?.length > 0 && matchingOptions.push(matched?.[0]);
                })
                setSbMatchedOptions(matchingOptions);
            }
        }
      if (responseList?.length > 0 && content?.preselectedOptionIds?.length > 0 && content?.optionType === 'multi-popup') {
        let preSelectedlist: any[] = [];
        let preSelectedIds: any[] = [];
        let beneficiaryProductList: any[] = [];
        (responseList || [])?.forEach((resp: any) => {
          const grpName = resp?.group?.toLowerCase() ?? '';
          resp?.serviceOption?.length > 0 &&
            (resp?.serviceOption || [])?.forEach((opt: any) => {
              if (content?.preselectedOptionIds?.some((pre: any) => pre?.text === opt?.id)) {
                preSelectedIds?.push(opt?.id)
                opt?.beneficiaryProduct?.length > 0 && beneficiaryProductList?.push(...opt?.beneficiaryProduct);
                preSelectedlist.push({
                  ...opt,
                  group: grpName,
                  count: 1,
                  beneficiaryPrice: 0
                });
              }
            });
        });
        if (beneficiaryProductList?.some((prod: any) => preSelectedIds?.includes(prod?.id))) {
            preSelectedlist = (preSelectedlist || [])?.map((sel: any) => {
                const product = (beneficiaryProductList || [])?.filter((prod: any) => prod?.id === sel?.id)
                if (product?.length > 0) {
                    return {...sel, beneficiaryPrice: product?.[0]?.derivedPrice}
                } else {
                    return sel;
                }
            })
        }
        preSelectedlist?.length > 0 && setSelectedOptions(preSelectedlist);
      }
    }, [responseList]);

    const toggleClick = () => {
        setOptionToggle(!optionToggle);
    }

    const addOptionsCallBack = (options: any) => {
        setSelectedOptions(options);
    };

    return (
        <>
            {/* Multi option with Popup */}
            {content?.optionType === 'multi-popup' &&
                <div className={`${Styles.mainWrapper} ${darkTheme && Styles.mainWrapperDark}`} style={{ gap: 0 }}>
                    <div className={Styles.titlesection}>
                        <div className={`${Styles.title} ${darkTheme && Styles.darkTheme}`}>{content?.optionTitle}</div>
                        {!content?.hidePopupIcon && 
                            <div className={Styles.pointer} onClick={() => setShowPopup(!showPopup)}>
                                <img src={`${getStaticAssetPath(iconSource)}`} width={24} height={24} alt='icon'/>
                            </div>
                        }
                    </div>
                    <div>
                        <div className={`${Styles.description} ${darkTheme && Styles.darkTheme}`}>
                            <RichText content={content?.optionDescription} />
                        </div>
                        <div className={`${Styles.optionsection} row`} style={{ paddingTop: '8px' }}>
                            {content?.optionGroup && content?.optionGroup?.length > 0 && content?.optionGroup?.map((item: any, index: number) => {
                                return (
                                    <div className={`${Styles.transBorder} ${selectedOptions?.some((option: any) => option?.group?.toLowerCase() === item?.text?.toLowerCase()) && Styles.selectedBorder} col-2`}>
                                        <div className={Styles.icon}><img src={item?.icon?.filename} className={Styles.iconSize} alt='icon'/></div>
                                        {selectedOptions?.some((option: any) => option?.group?.toLowerCase() === item?.text?.toLowerCase()) && <div className={Styles.overlayIcon}>
                                            <img src={`${assetPath}/icons/lineCheck-success.svg`} width={12} height={12} alt='success'/>
                                        </div>}
                                    </div>
                                )
                            })}
                        </div>
                        {selectedOptions?.length > 0 && <div className={Styles.bottomSection}>
                            {selectedOptions?.length > 1 && content?.selectedLbl && <div className={`${Styles.pricetext} ${darkTheme && Styles.darkTheme}`}>
                                {replacePlaceholder(content?.selectedLbl, [selectedOptions?.length])}
                            </div>}
                            <div className={Styles.priceSection}>
                                {discountedPrice > 0 && <div className={`${Styles.pricetext} ${darkTheme && Styles.darkTheme}`}>{`+${countZero(discountedPrice)}${constants.month}`}</div>}
                                {discountedPrice > 0 && <div className={`${darkTheme ? Styles.strikeDarkTheme : Styles.strikePrice}`}>{`+${countZero(originalPrice)}${constants.month}`}</div>}
                                {discountedPrice === 0 && <div className={`${darkTheme ? Styles.darkThemePrice : Styles.lightThemePrice}`}>{`+${countZero(originalPrice)}${constants.month}`}</div>}
                            </div>
                        </div>}
                        {contractDuration > 0 && content?.optionsDurationText && (
                            <div className={Styles.contractDuration}>
                            {replacePlaceholder(content?.optionsDurationText, [contractDuration])}
                            </div>
                        )}
                    </div>
                </div>}

            {/* Multi option with Switcher */}
            {content?.optionType === 'multi-switcher' &&
                <div className={`${Styles.mainWrapper} ${darkTheme && Styles.mainWrapperDark}`}>
                    <div className={Styles.titlesection}>
                        <div className={`${Styles.title} ${darkTheme && Styles.darkTheme}`}>{content?.optionTitle}</div>
                        <div className={Styles.toggleWrapper}>
                            {originalPrice > 0 && <div className={`${Styles.price} ${darkTheme && Styles.darkTheme}`}>
                                {`+${countZero(discountedPrice > 0 ? discountedPrice : originalPrice)}${constants.month}`}
                            </div>}
                            <span className={Styles.toggle}>
                                <Form>
                                    <Form.Check
                                        type='switch'
                                        readOnly={true}
                                        onClick={toggleClick}
                                    />
                                </Form>
                            </span>
                        </div>
                    </div>
                    <div className={Styles.optionsection}>
                        {content?.optionId && content?.optionId?.length > 0 && content?.optionId?.map((item: any) => {
                            return (
                                <div><img src={item?.icon?.filename} width={64} height={64} alt='icon'/></div>
                            )
                        })}
                    </div>
                </div>}

            {/* Multi option with Switcher V2*/}
            {content?.optionType === 'multi-switcher-v2' &&
                <div className={`${Styles.mainWrapper} ${darkTheme && Styles.mainWrapperDark}`}>
                    <div>
                    <div className={Styles.titlesection}>
                        <div className={`${Styles.title} ${darkTheme && Styles.darkTheme}`}>{content?.optionTitle}</div>
                        {content?.optionTooltip && <ToolTip content={content?.optionTooltip}/>}
                    </div>
                    {content?.optionDescription && <div className={Styles.subTitle}><RichText content={content?.optionDescription} /></div>} 
                    </div>
                    <div className={Styles.optionsectionV2}>
                        <div className={Styles.optionIcons}>
                        {content?.optionId && content?.optionId?.length > 0 && content?.optionId?.map((item: any) => {
                            return (
                                <img src={item?.icon?.filename} width={64} height={64} alt='icon'/>
                            )
                        })}
                        </div>
                        {(discountedPrice > 0 || originalPrice > 0) && (
                        <>
                            <hr className={Styles.horizontalLine}/>
                            <div className={Styles.toggleWrapper}>
                            <div className='d-flex align-items-center'>
                                {(discountedPrice > 0 || originalPrice > 0) && (
                                <div className={`${Styles.priceV2} ${darkTheme && Styles.darkTheme}`}>
                                    {`+${countZero(discountedPrice > 0 ? discountedPrice : originalPrice)}${
                                    constants.month
                                    }`}
                                </div>
                                )}
                                {discountedPrice > 0 && (
                                <div
                                    className={`${Styles.basePriceV2} ${darkTheme && Styles.darkTheme}`}
                                >{`+${countZero(originalPrice)}${constants.month}`}</div>
                                )}
                            </div>
                            <span className={Styles.toggle}>
                                <Form>
                                <Form.Check type='switch' readOnly={true} onClick={toggleClick} />
                                </Form>
                            </span>
                            </div>
                            </>)}
                    </div>
                </div>}

            {/* Single option with Switcher */}
            {content?.optionType === 'single-switcher' &&
                <div className={`${Styles.mainWrapper} ${darkTheme && Styles.mainWrapperDark}`}>
                    <div className={Styles.titlesection}>
                        <div className={`${Styles.title} ${darkTheme && Styles.darkTheme}`}>{content?.optionTitle}</div>
                        <div className={Styles.toggleWrapper}>
                            {originalPrice > 0 && <div className={`${Styles.price} ${darkTheme && Styles.darkTheme}`}>
                                {`+${countZero(discountedPrice > 0 ? discountedPrice : originalPrice)}${constants.month}`}
                            </div>}
                            <span className={Styles.toggle}>
                                <Form>
                                    <Form.Check
                                        type='switch'
                                        readOnly={true}
                                        onClick={toggleClick}
                                    />
                                </Form>
                            </span>
                        </div>
                    </div>
                    {content?.optionId && content?.optionId.length > 0 && <div className={Styles.optionsection}>
                        <img src={content?.optionId?.[0]?.icon?.filename} width={64} height={64} alt='icon'/>
                        {content?.optionDescription && <div className={`${Styles.pricetext} ${darkTheme && Styles.darkTheme}`}>
                            <RichText content={content?.optionDescription} />
                        </div>}
                    </div>}
                </div>}
            {showPopup &&
                portalPosition &&
                content?.optionsPopup?.length > 0 &&
                createPortal(
                    <OttServiceOptionsPopup
                        content={content?.optionsPopup?.[0]}
                        showPopup={showPopup}
                        setShowPopup={setShowPopup}
                        addOptionsCallBack={addOptionsCallBack}
                        metadata={metadata}
                        constants={constants}
                        mainContent={content}
                        preSelectedOptions={selectedOptions}
                        optionsResponse={responseList}
                        updateResponseList={setResponseList}
                    />,
                    portalPosition
                )}
        </>
    );
}

export default TvOptionsContainer;
